import axios from "axios";
import { IP } from "utils/Host";
import { getClients } from "actions/getClients";
import { getMaxID } from "actions/getMaxID";
import { today_teraz } from "actions/today_teraz";

export const skasujTechnologieNew = async (grupaWykonan,grupaOprawaTech,technologia_id,zamowienie_id,user_id,refZamPagination,setShowTechnologyStage
) => {

  await axios
    .put(IP + "skasujTechnologieNew/" + sessionStorage.getItem("token"), [grupaWykonan,grupaOprawaTech,technologia_id,zamowienie_id,user_id])
    .then((res) => {
     setShowTechnologyStage(false);
     refZamPagination();
    });
};
//